import { Heading } from 'react-aria-components'
import { Icon } from '~/ui/Icon'

export const ConfirmationMessage = () => {
  return (
    <>
      <Heading slot="title" className="text-lg font-bold pb-3">
        Feedback Submitted
      </Heading>
      <div className="flex flex-col items-center gap-3">
        <Icon name="checkCircle" size={48} />
        <div>Thank you for your feedback!</div>
      </div>
    </>
  )
}
